import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import '../index.scss'
import ModalPortal from '@Components/Popups/ModalPortal'
import Sidebar from '@Components/Sidebars/Sidebar'
import { StoresContext } from '@App/contexts'
import AddPublishersArea from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep/AddPublishersArea'
import { PublisherSideBarState } from '@App/enum/publisher-side-bar-state'
import RootStore from '@App/stores/root-store'
import WizardStepHeading from '@Components/WizardFlow/WizardStepHeading'
import { WorkType } from '@Components/ViewWork/work-type'
import PublisherRemainingShareCount from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep/PublisherRemainingShareCount'
import OverclaimWarningStep from '@Components/Navigations/CreateWorkBottomNavs/ConfirmSubmission/OverclaimWarningStep'
import { isOverclaimAllowed } from '@App/helpers/is-overclaim-allowed'
import PublisherSidebarContent from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep/PublisherSidebarContent/index'

interface PublishersStepProps {
    workType?: WorkType
}

const PublishersStep = ({ workType }: PublishersStepProps) => {
    const { workStore, popupStore, publisherStepStore, wizardFlowStore } = useContext<RootStore>(StoresContext)

    const workDraftFromLocal = workStore.workDraftLocal
    const sidebarState = popupStore.publisherSidebarState
    if (!workDraftFromLocal) {
        return null
    }

    const editingOP = publisherStepStore.editingOP

    return (
        <div className="publishers-step">
            <WizardStepHeading heading="Add Publishers & Shares" title={workDraftFromLocal.title}>
                Enter your publisher(s)/administrator(s).
            </WizardStepHeading>

            {workType === 'claim-wizard' && !isOverclaimAllowed(workStore.workDraftLocal) && (
                <PublisherRemainingShareCount />
            )}

            <div className="publishers-cards-wrapper">
                <AddPublishersArea />
            </div>

            <ModalPortal isOpen={workStore.overclaimWarningOpen}>
                <OverclaimWarningStep
                    onClickConfirm={() => {
                        workStore.setOverclaimWarningOpen(false)
                        wizardFlowStore.advanceIndex()
                    }}
                    onClickCancel={() => workStore.setOverclaimWarningOpen(false)}
                />
            </ModalPortal>

            <ModalPortal
                isOpen={sidebarState !== PublisherSideBarState.empty}
                onClose={() => popupStore.setPublisherSidebarState(PublisherSideBarState.empty)}
            >
                <Sidebar onClose={() => popupStore.setPublisherSidebarState(PublisherSideBarState.empty)}>
                    <PublisherSidebarContent sidebarState={sidebarState} editingOP={editingOP} />
                </Sidebar>
            </ModalPortal>
        </div>
    )
}

export default observer(PublishersStep)
